module.exports = __webpack_public_path__ + "static/img/master-bl-no-result.44d0c7ae.svg";